<template>
  <div>
    <div class="heading-4">Deposit</div>
    <c-tx-steps
      class="mt-6"
      :options="steps"
      :current="currentStep"
      bgColor="purple"
    />
    <template v-if="currentStep === 1">
      <div class="mt-8 text-5">
        <div>Enter amount to deposit</div>
        <enter-amount
          class="mt-5"
          v-model="form.amount"
          :maxAmount="maxAmountIncludingFee"
          :suffix="currentProject.staking.token"
        />
        <v-divider class="border-stake mt-5"></v-divider>
        <div class="d-flex align-center justify-end mt-5">
          <c-btn
            @click="currentStep = 2"
            :disabled="form.amount <= 0"
            walletRequired
            >Continue</c-btn
          >
        </div>
      </div>
    </template>
    <template v-if="currentStep === 2">
      <gas-option :gas="defaultGas" v-model="gasOption" class="mt-8">
        <br />
      </gas-option>
      <v-divider class="mt-5 border-stake"></v-divider>
      <div class="mt-5 text-4">
        <span class="font-weight-medium">Transaction Fee:</span>
        <span class="darkgray--text ml-4">
          <span>{{ gasOption.gasPrice | denomFormat }}</span>
          <span class="gray--text text-uppercase ml-1 text-5">{{
            currentProject.staking.token
          }}</span>
        </span>
      </div>
      <div class="mt-3 text-4">
        <span class="font-weight-medium">Deposit Amount:</span>
        <span class="darkgray--text ml-4">{{ form.amount | denomFormat }}</span>
        <span class="gray--text text-uppercase ml-1 text-5">{{
          currentProject.staking.token
        }}</span>
      </div>
      <v-divider class="mt-5 border-stake"></v-divider>
      <div class="d-flex align-center justify-end mt-5">
        <c-btn
          @click="confirm"
          :disabled="gasOption.gas <= 0 || gasOption.gasPrice <= 0"
          walletRequired
          >Deposit</c-btn
        >
      </div>
    </template>
    <tx-tendermint
      v-if="showTxDialog"
      name="gov_deposit"
      title="Deposit"
      successMesssage="Transaction sent"
      :getRawTx="getRawTx"
      :metadata="{ amount: form.amount, id: proposal.id }"
      :gasOption="gasOption"
      @cancel="showTxDialog = false"
      @onSuccess="onTxSuccess"
    >
    </tx-tendermint>
  </div>
</template>

<script>
import BN from "bignumber.js";
import { mapGetters } from "vuex";
import GasOption from "../../components/GasOption";
import EnterAmount from "@/views/stake/components/tx/EnterAmount.vue";

export default {
  components: {
    GasOption,
    EnterAmount,
  },
  props: {
    proposal: Object,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      accountInfo: "staking/tendermint/accountInfo",
    }),
    availableBalance() {
      return new BN(this.accountInfo?.result?.total ?? 0)
        .dividedBy(this.currentProject.staking.conversionRate)
        .toString();
    },
    defaultGas() {
      return this.currentProject.staking.gas.GovDeposit;
    },
    defaultGasPrice() {
      return new BN(this.currentProject.staking.gasPriceStep.medium)
        .multipliedBy(this.defaultGas)
        .div(this.currentProject.staking.conversionRate)
        .toNumber();
    },
    gasPriceUsd() {
      return (
        this.getTokenPriceInUsd(this.currentProject.staking.token) *
        this.gasOption.gasPrice
      );
    },
    maxAmount() {
      let amt = new BN(this.availableBalance);
      if (this.shouldWithdrawRewards) {
        amt = amt.plus(this.totalRewards);
      }
      return amt.toNumber();
    },
    maxAmountIncludingFee() {
      return Math.max(
        new BN(this.maxAmount)
          .minus(this.gasOption.gasPrice || this.defaultGasPrice)
          .toNumber(),
        0
      );
    },
  },
  data: () => ({
    currentStep: 1,
    steps: [
      {
        step: 1,
        text: "Enter amount",
      },
      {
        step: 2,
        text: "Gas option",
      },
    ],
    form: {
      amount: 0,
    },
    gasOption: {
      gas: 0,
      gasPrice: 0,
    },
    showTxDialog: false,
  }),
  methods: {
    confirm() {
      this.showTxDialog = true;
    },
    async onTxSuccess() {
      this.showTxDialog = false;
      this.$emit("closeModal");
    },
    getRawTx() {
      return this.$store.dispatch("staking/tendermint/getGovDepositRawTx", {
        proposalId: this.proposal.id,
        amount: this.form.amount,
        memo: "",
        gas: this.gasOption.gas,
        gasPrice: new BN(this.gasOption.gasPrice)
          .multipliedBy(this.currentProject.staking.conversionRate)
          .toNumber(),
      });
    },
  },
};
</script>
